/**
 * A {@code Model} for maintaining the list of Algorithms supported by the application.
 */
import SelectableItemModel from './selectable-item-model';

export default class AlgorithmsModel extends SelectableItemModel {

  constructor() {
    super();

    // Build the list of Algorithms support by the system.
    this._internalCache = [
      {
        id: 'nearest-neighbour',
        name: 'Nearest Neighbour'
      },
      {
        id: 'inverseDistWeight-p1-n4',
        name: 'Inverse Distance Weight (p=1, n=4)'
      },
      {
        id: 'inverseDistWeight-p1-n6',
        name: 'Inverse Distance Weight (p=1, n=6)'
      },
      {
        id: 'inverseDistWeight-p2-n4',
        name: 'Inverse Distance Weight (p=2, n=4)'
      },
      {
        id: 'inverseDistWeight-p2-n6',
        name: 'Inverse Distance Weight (p=2, n=6)'
      },
    ];

    // Declare instance properties.
    this._selectedItem = this._internalCache[0];

  }

}



// WEBPACK FOOTER //
// ./src/app/models/algorithms-model.js